import { render, staticRenderFns } from "./Develop.vue?vue&type=template&id=0a0a92e8&scoped=true&"
import script from "./Develop.vue?vue&type=script&lang=js&"
export * from "./Develop.vue?vue&type=script&lang=js&"
import style0 from "./Develop.vue?vue&type=style&index=0&id=0a0a92e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0a92e8",
  null
  
)

export default component.exports